module.exports = __webpack_public_path__ + "550a6d98e906f3e29571d5b05120ca87.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/action-center-employees/icon2.jpg
// module id = 1504
// module chunks = 0